import { getDefaultState } from '../getDefaultState';
import { TState } from '../types';

interface IAction {
  type: 'RESET DEFAULT STATE';
}
export type TResetDefaultStateAction = Readonly<IAction>;

export const resetDefaultState = (_state: TState, _action: TResetDefaultStateAction): TState => getDefaultState();
